import React from 'react'

/**
 * 新しいタブで指定されたURLを開くカスタムフックです。
 *
 * @returns URLを新しいタブで開く関数
 */
export const useOpenUrlInNewTab = () =>
  React.useCallback((url: string) => {
    const elm = window.document.createElement('a')
    elm.href = url
    elm.target = '_blank'
    elm.rel = 'noopener noreferrer'
    elm.click()
  }, [])
